
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[postId]",
      function () {
        return require("private-next-pages/event/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[postId]"])
      });
    }
  